document.addEventListener('DOMContentLoaded', function() {
    let swatches = document.querySelectorAll('.grid-product__swatch');
    swatches.forEach(function(swatch) {
        swatch.addEventListener('mouseover', function() {
            swatch.parentElement.querySelector('.grid-product__swatch--active').classList.remove('grid-product__swatch--active');
            swatch.classList.add('grid-product__swatch--active');
        });

        swatch.addEventListener('mouseout', function() {
            swatch.classList.remove('grid-product__swatch--active');
            let activeSwatch = swatch.parentElement.querySelector('.grid-product__swatch[data-active="true"]');
            if (activeSwatch) {
                activeSwatch.classList.add('grid-product__swatch--active');
            }
        });
    });
});

// ALOHRA: Lock colour swatch scroll to horizontal axis only
document.addEventListener('DOMContentLoaded', function() {
  var swatchLists = document.querySelectorAll('.product-single__swatches-list');
  swatchLists.forEach(function(el) {
    var startX, startY, startScrollLeft;

    el.addEventListener('touchstart', function(e) {
      startX = e.touches[0].pageX;
      startY = e.touches[0].pageY;
      startScrollLeft = el.scrollLeft;
    }, { passive: true });

    el.addEventListener('touchmove', function(e) {
      var dx = e.touches[0].pageX - startX;
      var dy = e.touches[0].pageY - startY;
      // Only handle if more horizontal than vertical
      if (Math.abs(dx) > Math.abs(dy)) {
        e.preventDefault();
        el.scrollLeft = startScrollLeft - dx;
      }
    }, { passive: false });
  });
});
